import { type PriceBook, PriceBookModel } from '@/http/models/PosCatalog'
import { Tags, Users } from 'lucide-react'

import { useEffect, useState } from 'react'

import { Badge } from '@/components/ui/badge'

import { BookCustomersDialog } from '@/components/features/pos/BookCustomersDialog'
import { BookPricesDialog } from '@/components/features/pos/BookPricesDialog'
import { ResourcePage } from '@/components/features/pos/ResourcePage'

const PriceBooks = () => {
  const [pricesOf, setPricesOf] = useState<PriceBook | null>(null)
  const [customersOf, setCustomersOf] = useState<PriceBook | null>(null)
  const [books, setBooks] = useState<PriceBook[]>([])
  useEffect(() => {
    PriceBookModel.getList({ length: 200 }).then((res) => res.success && res.data && setBooks(res.data.result))
  }, [customersOf])
  return (
    <>
      <ResourcePage<PriceBook>
        title="Price books"
        description="Named price lists for customer groups, used across all branches."
        noun="price book"
        api={PriceBookModel}
        permissions={{
          create: 'price_books:create',
          update: 'price_books:update',
          delete: 'price_books:delete',
        }}
        searchPlaceholder="Search by title"
        columns={[
          {
            label: 'Title',
            render: (b) => <span className="font-medium text-ink">{b.title}</span>,
          },
          {
            label: 'Description',
            render: (b) => b.description || '—',
            className: 'hidden md:table-cell',
          },
          {
            label: 'Status',
            render: (b) => (
              <Badge tone={b.status === 'active' ? 'success' : 'soft'}>
                {b.status === 'active' ? 'Active' : 'Inactive'}
              </Badge>
            ),
          },
        ]}
        fields={[
          { name: 'title', label: 'Title', type: 'text', required: true, placeholder: 'Wholesale' },
          { name: 'description', label: 'Description', type: 'textarea' },
          { name: 'status', label: 'Active', type: 'status' },
        ]}
        toForm={(b) => ({
          title: b?.title ?? '',
          description: b?.description ?? '',
          status: (b?.status ?? 'active') === 'active',
        })}
        rowActions={(b) => [
          { label: 'Prices', icon: Tags, permission: 'price_books:details', onClick: () => setPricesOf(b) },
          { label: 'Customers', icon: Users, permission: 'customers:list', onClick: () => setCustomersOf(b) },
        ]}
      />
      <BookPricesDialog book={pricesOf} onClose={() => setPricesOf(null)} />
      <BookCustomersDialog book={customersOf} books={books} onClose={() => setCustomersOf(null)} />
    </>
  )
}

export default PriceBooks
